import React from "react";
import iconScore from "src/assets/imgs/score-icon.png";
import Container from "./styles";

const ReloadComponent: React.FC = () => (
	<Container>
		<img className="home-page-icon" src={iconScore} alt="Home Page" />
	</Container>
);

export default ReloadComponent;
